import './assets/ListItem.css';const o = "_root_1pvf0_2", t = "_chevron_1pvf0_51", h = "_withBottomShadow_1pvf0_74", _ = {
  root: o,
  chevron: t,
  withBottomShadow: h
};
export {
  _ as S
};
